module.exports = __webpack_public_path__ + "media/images/techcrunch-08b6d7cd40bf5083eb53bb59948e164555fc6b2733c5d266428095d1499741c3.jpg";